import facebook from "./facebook.png";
import twitter from "./twitter.png";
import instagram from "./instagram.png";

const exports = [facebook, twitter, instagram];

export default exports;
